import * as apiAlert from '@/api/alert'
import * as _ from 'lodash'
import store from '@/store'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    complete: false,
    canload: true,
    start: 0,
    per_page: 100,
    count: null,
    currentId: null,
    unreadCount: 0
  }

  return defaults
}

const alert = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists, list => list.id === state.currentId)
  },
  mutations: {
    setLists: (state, lists) => {
      state.lists.push(...lists)
    },
    setStart: (state, num) => {
      state.start = num
    },
    deleteCount: (state) => {
      state.count = 0
    },
    setCount: (state, num) => {
      if (num > state.per_page) {
        state.count = state.per_page
      } else {
        state.count = num
      }
    },
    setUnreadCount: (state, num) => {
      state.unreadCount = num
    },
    subtractionCount: (state) => {
      state.count--
    },
    setComplete: (state) => {
      state.complete = true
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
    },
    resetComplete: (state) => {
      state.complete = false
    },
    resetAll: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentId = id
    },
    deleteList: (state, index) => {
      state.lists.splice(index, 1)
    }
  },
  actions: {
    getLists: async ({ commit, state, dispatch }) => {
      commit('resetLists')
      commit('deleteCount')
      commit('resetComplete')

      const params = {
        start: state.start,
        per_page: state.per_page,
        search_order: 'created', // date(作成日順)
        ascending: 'desc'
      }
      if (state.canload) {
        commit('setCanload', false)
        const res = await apiAlert
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              let { lists } = data
              let counter = -1

              // 削除済をここで除外
              lists = _.filter(lists, list => list.deleated !== 1)
              counter = lists.length

              // 初期表示時に全件取得
              await commit('setLists', lists)
              commit('setCount', counter)

              const params = {
                is_unread_only: 1
              }
              apiAlert
                .count(params)
                .then(response => {
                  const { data } = response
                  if (data.status === 0) {
                    store.dispatch('alert/setUnreadCount', data.count)
                  }
                })
            } else {
              // status=その他: エラーダイアログを表示
              store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
            }
            return data
          })
          .finally(() => {
            commit('setCanload', true)
            commit('setComplete')
          })
        return res
      }
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id) 
    },
    delete: async ({ commit, state }, params) => {
      const response = await apiAlert.remove(params)
      const { data } = response
      if (data.status === 0) {
        const index = _.findIndex(state.lists, list => list.alert_id === params.id)
        commit('deleteList', index)
        commit('subtractionCount')
      }
      return response
    },
    deleteAll: async ({ commit, state }, params) => {
      await apiAlert
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('resetLists')
            commit('deleteCount')
            commit('setComplete')
          }
        })
    },
    setUnreadCount: ({ commit }, num) => {
      commit('setUnreadCount', num)
    }
  }
}

export default alert
